module.exports = __webpack_public_path__ + "static/media/ic-add-grey.82b2c652.svg";